(() => {
  if (window.apPurchaseDetailsReady) return;
  window.apPurchaseDetailsReady = true;
  const init = () => document.querySelectorAll('.ap-purchase-area').forEach(area => {
    if (area.dataset.apReady) return;
    area.dataset.apReady = 'true';
    const stock = area.querySelector('[data-ap-stock]');
    const variants = JSON.parse(area.querySelector('[data-ap-stock-variants]')?.textContent || '[]');
    const update = variant => {
      if (!stock) return;
      const v = variants.find(item => String(item.id) === String(variant?.id));
      stock.hidden = !v?.available;
      area.querySelector('[data-ap-shipping]').hidden = !v?.available;
      if (!v?.available) return;
      const low = v.tracked && v.quantity > 0 && v.quantity <= 10;
      stock.classList.toggle('is-available', !low);
      stock.querySelector('[data-ap-stock-text]').textContent = 'Laos on alles vaid mõned tooted!';
    };
    const product = area.closest('[id^="Product--"]');
    product?.addEventListener('theme:variant:change', event => update(event.detail?.variant));
    const initialId = area.querySelector('input[name="id"], select[name="id"]')?.value || stock?.dataset.apCurrentVariant;
    if (initialId) update({ id: initialId });
    const date = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Tallinn' }));
    date.setDate(date.getDate() + 3);
    const formatted = new Intl.DateTimeFormat('et-EE', { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
    area.querySelectorAll('[data-ap-dispatch-date]').forEach(el => { el.textContent = formatted; });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();